import { render, staticRenderFns } from "./vehicleReviewList.vue?vue&type=template&id=0d19a4e7"
import script from "./vehicleReviewList.vue?vue&type=script&lang=js"
export * from "./vehicleReviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports